<template>
  <div>
    <b-collapse id="collapse-support" class="mt-1">
      <b-card class="tab-container" no-body>
        <b-tabs v-model="tabIndex" fill>
          <b-tab title="Begeleiding" :title-link-class="linkClass(0)" active>
            <div class="support-container">
              <div class="wide-container">
                <SupportCard v-for="(item, i) in tour" :key="i" :title="tour[i].title" :img="tour[i].img"/>
              </div>
            </div>
          </b-tab>
          <b-tab title="Setup" :title-link-class="linkClass(1)">
            <div class="support-container">
              <div class="wide-container">
                <SupportCard v-for="(item, i) in setup" :key="i" :title="setup[i].title" :img="setup[i].img"/>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>

    </b-collapse>
    <font-awesome-icon v-b-toggle.collapse-support class="chevron-down" :class="rotate" v-on:click="rotateIcon"
                       icon="chevron-down"/>
  </div>
</template>

<script>
import tour from '../assets/json/support-tour.json';
import setup from '../assets/json/support-setup.json';
import SupportCard from "./subcomponents/SupportCard";

export default {
  name: "Support",
  data() {
    return {
      tour: tour,
      setup: setup,
      rotate: null,
      tabIndex: 0
    }
  },
  components: {
    SupportCard
  },
  methods: {
    rotateIcon() {
      this.rotate = this.rotate === null ? 'rotate' : null;
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-transparent', 'text-light', 'border-dark']
      } else {
        return ['bg-transparent', 'text-secondary', 'border-dark']
      }
    }
  }
}
</script>

<style scoped>
.support-container {
  height: 420px;
  overflow-x: scroll;
  overflow-y: hidden;
}

.wide-container {
  display: flex;
  flex-direction: row;
  width: fit-content;
}

/* width */
::-webkit-scrollbar {
  height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: black;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.rotate {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

.chevron-down {
  cursor: pointer;
}

.tab-container {
  background-color: rgba(0, 0, 0, 0.90);
  font-family: "Gotham Book", serif;
  z-index: 1;
}
</style>